import { getDataFromServer } from "../util";

export const sendWelcomeOnboardingEmails = () => getDataFromServer("POST", "/scripts/emails/welcome-onboarding", null, true);

export const syncUsersWithSumsub = () => getDataFromServer("POST", "/integrations/sumsub/sync", null, true);
